import React from "react";
import { Link, useRouteMatch } from "react-router-dom";

import { DefinedRoute, RouteParams, substituteRouteParameters } from "routes";

export const Breadcrumb = React.memo(
  ({ routes }: { routes: DefinedRoute[] }) => {
    const { path: currentPath, params } = useRouteMatch<RouteParams>();

    const routesLeadingToCurrentPath = routes.filter(
      ({ path }) =>
        currentPath.startsWith(path) && (path !== "/" || currentPath === path)
    );
    const crumbs = substituteRouteParameters(
      routesLeadingToCurrentPath,
      params
    );
    document.title = `Relectrify - ${crumbs.map((x) => x.title).join(" - ")}`;
    return (
      <>
        <Link to="/" className="block">
          <svg
            className="h-8 w-8 -mt-px text-blue-600 hover:text-blue-400"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M18.672,11H17v6c0,0.445-0.194,1-1,1h-4v-6H8v6H4c-0.806,0-1-0.555-1-1v-6H1.328 c-0.598,0-0.47-0.324-0.06-0.748L9.292,2.22C9.487,2.018,9.743,1.918,10,1.908c0.257,0.01,0.513,0.109,0.708,0.312l8.023,8.031 C19.142,10.676,19.27,11,18.672,11z" />
          </svg>
        </Link>
        {crumbs.length > 0 && (
          <span className="mr-2 ml-2 text-gray-600">:</span>
        )}
        {crumbs.map(({ path, title }, index) => (
          <span key={index}>
            {index === crumbs.length - 1 ? (
              title
            ) : (
              <Link to={path} className="text-blue-600 hover:text-blue-400">
                {title}
              </Link>
            )}
            {index < crumbs.length - 1 && (
              <span className="mr-2 ml-2 text-gray-600">:</span>
            )}
          </span>
        ))}
      </>
    );
  }
);
